import { _LIST_PAGINATION_MODEL } from '../../../../../store/modules/app/models';

export const PRODUCT_LIST_FILTER_OPTION_MODEL = {
  status: null,
};

export const INITIAL_OPTION_MODEL = {
  filterOption: PRODUCT_LIST_FILTER_OPTION_MODEL,
  pagination: _LIST_PAGINATION_MODEL,
};
